/*
  Gamma Brewing — BYOB "Your bundle" panel and card counters.

  Loaded by sections/byob-styles.liquid, which also renders the empty stand-in
  panel and the #byob-panel-config JSON island this reads its labels from.

  NOTE FOR LOCAL DEVELOPMENT: the BYOB app loads yett in whitelist mode. Its
  list covers shopify.com and gammabrewing.com, so this file runs fine in
  production — but `shopify theme dev` serves assets from 127.0.0.1, which is
  not on the list, and yett strips the tag before it runs. The file is fetched
  (200) and then silently never executes. So on the local preview the panel
  renders without its heading, count, progress bar or card counters. That is
  the dev server, not a bug in this file.
*/
/*
  "Your bundle" panel.

  The BYOB footer block renders the selected variants and the add-to-cart
  button, but not the heading, the "N cans in the box" count or the progress
  bar the design calls for — none of that data is in its markup.

  This injects those three pieces and keeps them in sync:
    - target quantity comes from the app's own `buildrule` / `buildrules`
      globals, which it writes into the page
    - current quantity is summed from the "x N" text on each row, so we read
      only rendered output and never reach into the app's Vue internals

  The panel is re-patched by Vue whenever the bundle changes, so the observer
  re-inserts the header if a patch drops it.
*/
(function () {
  'use strict';

  var HEAD = 'byob-panel-head';

  // Editor text comes through a JSON island rather than Liquid interpolation,
  // now that this lives in an asset file.
  var settings = (function () {
    var el = document.getElementById('byob-panel-config');
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch (error) {
      return {};
    }
  })();

  var titleText = settings.title || 'Your bundle';
  var labelText = settings.label || 'cans in the box';

  function targetQuantity() {
    var rules = window.buildrules;
    if (Array.isArray(rules) && rules.length) {
      return rules.reduce(function (sum, rule) {
        return sum + (Number(rule && rule.quantity) || 0);
      }, 0);
    }
    return Number(window.buildrule && window.buildrule.quantity) || 0;
  }

  function currentQuantity(footer) {
    var total = 0;
    footer.querySelectorAll('.byob-footer-card .byob-footer-thumbnail-detail').forEach(function (detail) {
      // the app prints the per-variant count as a bare "x 4" div
      var match = (detail.textContent || '').match(/x\s*(\d+)\s*$/i);
      total += match ? Number(match[1]) : 0;
    });
    return total;
  }

  function buildHead() {
    var head = document.createElement('div');
    head.className = HEAD;
    head.innerHTML =
      '<div class="byob-panel-title"></div>' +
      '<div class="byob-panel-count">' +
      '<span class="byob-panel-count-num">0</span>' +
      '<span class="byob-panel-count-label"></span>' +
      '</div>' +
      '<div class="byob-panel-progress"><span style="width:0%"></span></div>';
    head.querySelector('.byob-panel-title').textContent = titleText;
    head.querySelector('.byob-panel-count-label').textContent = labelText;
    return head;
  }

  // Keep the panel level with the top of the grid, then pin it near the top
  // of the viewport once that scrolls past. Plain `position: sticky` is not
  // an option: the app teleports .byob-footer to <body>, so it has no
  // scrolling ancestor in common with the grid.
  var PANEL_GAP = 24;
  var PANEL_WIDTH = 412;
  var PANEL_TO_GRID = 30;

  // The theme's header is sticky, so "pinned to the top of the viewport" has
  // to mean below the header, not under it.
  function stickyHeaderBottom() {
    var header = document.querySelector('header.shopify-section-group-header-group')
      || document.querySelector('header');
    if (!header) return 0;
    var position = getComputedStyle(header).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;
    return Math.max(0, header.getBoundingClientRect().bottom);
  }

  // Below the left-rail breakpoint the panel is a bottom bar, so the list is
  // capped at a fixed number of rows rather than by the viewport. Measured
  // from a real row so it survives font or padding changes.
  var MOBILE_VISIBLE_ROWS = 3;

  function limitMobileList(footer) {
    if (!footer) return;
    var list = footer.querySelector('.byob-wrapper');
    if (!list) return;

    var row = footer.querySelector('.byob-footer-card');
    if (window.innerWidth >= 1200 || !row) {
      list.style.maxHeight = '';
      return;
    }

    var styles = getComputedStyle(list);
    var gap = parseFloat(styles.rowGap || styles.gap) || 0;
    var rowHeight = row.getBoundingClientRect().height;
    list.style.maxHeight =
      rowHeight * MOBILE_VISIBLE_ROWS + gap * (MOBILE_VISIBLE_ROWS - 1) + 'px';
  }

  function positionPanel() {
    var grid = document.querySelector('.grid-collection');
    var panels = [
      document.querySelector('.byob-footer'),
      document.querySelector('[data-byob-placeholder]')
    ];
    var minTop = stickyHeaderBottom() + PANEL_GAP;

    // Stop pinning at the last row: past that the panel rides up with the
    // grid instead of hanging on over the footer.
    var cards = document.querySelectorAll('.grid-collection .grid-product');
    var lastCard = cards[cards.length - 1];
    var maxTop = lastCard ? lastCard.getBoundingClientRect().top : Infinity;
    var cardHeight = cards[0] ? cards[0].getBoundingClientRect().height : Infinity;

    // Line the panel up off the grid itself rather than off the viewport, so
    // the 30px gap to the first column holds at every width. The stylesheet's
    // left is a fallback for before this runs.
    var panelLeft = cards[0]
      ? cards[0].getBoundingClientRect().left - PANEL_WIDTH - PANEL_TO_GRID
      : null;

    panels.forEach(function (panel) {
      if (!panel) return;
      if (window.innerWidth < 1200 || !grid) {
        panel.style.top = '';
        panel.style.left = '';
        panel.style.maxHeight = '';
        return;
      }

      if (panelLeft !== null) panel.style.left = Math.max(0, panelLeft) + 'px';
      var pinned = Math.max(minTop, grid.getBoundingClientRect().top);
      var top = Math.min(pinned, maxTop);
      panel.style.top = top + 'px';
      // Never taller than one product card, and never taller than the space
      // left in the viewport. The item list scrolls inside whatever is left.
      var available = window.innerHeight - Math.max(top, 0) - PANEL_GAP;
      panel.style.maxHeight = Math.max(160, Math.min(available, cardHeight)) + 'px';
    });
  }

  window.addEventListener('scroll', positionPanel, { passive: true });
  window.addEventListener('resize', function () {
    positionPanel();
    limitMobileList(document.querySelector('.byob-footer'));
  });

  // --- card counter -----------------------------------------------------
  // The app's card has no idea how many of itself are in the bundle, but the
  // panel does. So we read the count off the panel row and mirror it onto the
  // card, and drive changes through the app's own controls rather than its
  // Vue state: "+" clicks the card's Add button, "-" clicks that panel row's
  // remove icon (removeVariant splices exactly one, byob_footer_remove_quantity
  // defaults to 1). The app stays the source of truth throughout.

  // Nothing about a row may be cached on the row itself. Vue reuses row nodes
  // when the list changes, so a stashed value ends up describing a different
  // product -- which is how "minus" once removed the wrong can. The remove
  // icon's id (byob-remove-icon-<variantId>) IS kept in step by Vue, so that
  // is what everything keys off, resolved to a product through the app's own
  // json_products.
  function variantToProduct() {
    var map = {};
    (window.json_products || []).forEach(function (product) {
      (product.variants || []).forEach(function (variant) {
        map[variant.id] = product.title;
      });
    });
    return map;
  }

  function rowVariantId(row) {
    var close = row.querySelector('.byob-close');
    return close ? (close.id || '').replace('byob-remove-icon-', '') : '';
  }

  function rowProductName(row, names) {
    var name = names[rowVariantId(row)];
    if (name) return name;
    // fall back to the app's own label if json_products is unavailable
    var titleEl = row.querySelector('.card-title');
    if (!titleEl) return '';
    var full = (titleEl.getAttribute('title') || titleEl.textContent || '').trim();
    return full.split(' - ')[0].trim();
  }

  function cardName(card) {
    var link = card.querySelector('.grid-product-text');
    if (!link) return '';
    var clone = link.cloneNode(true);
    clone.querySelectorAll('.byob-product-type').forEach(function (node) {
      node.remove();
    });
    return clone.textContent.trim();
  }

  // product title -> { qty, remove }  (call after names have been trimmed)
  function panelRows(footer) {
    var map = {};
    if (!footer) return map;
    var names = variantToProduct();
    footer.querySelectorAll('.byob-footer-card').forEach(function (row) {
      var detail = row.querySelector('.byob-footer-thumbnail-detail');
      var close = row.querySelector('.byob-close');
      var name = rowProductName(row, names);
      if (!detail || !close || !name) return;
      var match = (detail.textContent || '').match(/x\s*(\d+)\s*$/i);
      map[name] = { qty: match ? Number(match[1]) : 0, remove: close };
    });
    return map;
  }

  function buildCardStepper() {
    var stepper = document.createElement('div');
    stepper.className = 'byob-card-stepper';
    stepper.setAttribute('data-byob-card-stepper', '');
    stepper.innerHTML =
      '<button type="button" data-byob-minus aria-label="Remove one">&minus;</button>' +
      '<output data-byob-card-qty>0</output>' +
      '<button type="button" data-byob-plus aria-label="Add one">+</button>';
    return stepper;
  }

  function syncCards(footer) {
    var rows = panelRows(footer);

    document.querySelectorAll('.grid-collection .grid-product').forEach(function (card) {
      var entry = rows[cardName(card)];
      var stepper = card.querySelector('[data-byob-card-stepper]');

      if (!entry || entry.qty < 1) {
        card.classList.remove('byob-has-qty');
        if (stepper) stepper.remove();
        return;
      }

      if (!stepper) {
        stepper = buildCardStepper();
        card.appendChild(stepper);
      }

      var addButton = card.querySelector('.btn-add-to-bundle');
      stepper.querySelector('[data-byob-card-qty]').textContent = entry.qty;
      stepper.querySelector('[data-byob-plus]').disabled = !addButton || addButton.disabled;
      card.classList.add('byob-has-qty');
    });
  }

  document.addEventListener('click', function (event) {
    var plus = event.target.closest('[data-byob-plus]');
    var minus = event.target.closest('[data-byob-minus]');
    if (!plus && !minus) return;

    var card = event.target.closest('.grid-product');
    if (!card) return;
    event.preventDefault();

    if (plus) {
      var addButton = card.querySelector('.btn-add-to-bundle');
      if (addButton && !addButton.disabled) addButton.click();
      return;
    }

    var entry = panelRows(document.querySelector('.byob-footer'))[cardName(card)];
    if (entry && entry.remove) entry.remove.click();
  });

  function sync() {
    var footer = document.querySelector('.byob-footer');

    // Hold the stand-in open until the app's own panel takes over. The app
    // also removes .byob-footer when the shopper minimises a non-empty
    // bundle (it leaves #byob-beacon behind), and the stand-in must stay
    // hidden then — otherwise it would claim the bundle is empty.
    var placeholder = document.querySelector('[data-byob-placeholder]');
    if (placeholder) {
      placeholder.hidden = !!footer || !!document.getElementById('byob-beacon');
    }

    positionPanel();
    limitMobileList(footer);

    if (!footer) {
      syncCards(null);
      return;
    }

    var head = footer.querySelector('.' + HEAD);
    if (!head) {
      head = buildHead();
      footer.insertBefore(head, footer.firstChild);
    }

    // The app labels each row with variant.name ("Vision Clear - Single can -
    // 55 DKK"); the design wants just the product. Recomputed from the row's
    // variant id every pass -- never stored on the row, and the app's own
    // title attribute is left alone so it stays a reliable fallback.
    var rowNames = variantToProduct();
    footer.querySelectorAll('.byob-footer-card').forEach(function (row) {
      var titleEl = row.querySelector('.card-title');
      var name = rowProductName(row, rowNames);
      if (titleEl && name && titleEl.textContent.trim() !== name) {
        titleEl.textContent = name;
      }
    });

    var current = currentQuantity(footer);
    var target = targetQuantity();

    head.querySelector('.byob-panel-count-num').textContent = current;
    head.querySelector('.byob-panel-progress > span').style.width =
      (target > 0 ? Math.min(100, (current / target) * 100) : 0) + '%';

    syncCards(footer);
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    // Placed synchronously, in the same task as the mutation: the app mounts
    // its panel with the stylesheet's fallback top, so waiting for the rAF
    // below would let it paint in the wrong place first.
    positionPanel();

    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      observer.disconnect();
      sync();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  });

  function start() {
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Place the panel before the first paint. This script is inline below both
  // the grid and the stand-in panel, so both are already parsed; waiting for
  // DOMContentLoaded would paint the panel at its CSS fallback top and then
  // visibly move it.
  positionPanel();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
